import {ChangeDetectorRef, Component, Input, OnInit, ViewChild,} from '@angular/core';
import {TableNomprCertiffourComponent} from './table-nompr-certiffour/table-nompr-certiffour.component';
import {PaginatorComponent} from 'src/app/modules/widget/components/paginator/paginator.component';
import {SearchOptions} from 'src/app/domain/fournisseur/certif-fournisseur-search';
import {SearchView} from '../../../projet-prog/projet-prog.component';
import {CertifFournisseur} from 'src/app/domain/fournisseur/certif-fournisseur';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {DatePipe} from '@angular/common';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {SearchObjectService} from 'src/app/modules/services/search-object/SearchObjectService';
import {Router} from '@angular/router';
import {SharedSearchService} from '../../../accueil/common/shared-search.service';
import {MatDialog} from '@angular/material/dialog';
import {CertifFournisseurService} from 'src/app/modules/services/fournisseur/certif-four/certif-fournisseur.service';
import {Pagination} from 'src/app/domain/Pagination';
import {CertifAchetService} from 'src/app/modules/services/acheteur/certif/certif-achet.service';
import {Transferid} from '../../../../content-layout/pages/fournisseur/details-offre-fornisseur/details-offre-fornisseur.component';
import {isEmpty} from '../../../../../utils/is-empty';

@Component({
    selector: 'app-list-filter-certiffour',
    templateUrl: './list-filter-certiffour.component.html',
    styleUrls: ['./list-filter-certiffour.component.css'],
})
export class ListFilterCertiffourComponent implements OnInit {
    @ViewChild(TableNomprCertiffourComponent)
    tableComponent: TableNomprCertiffourComponent;
    @ViewChild(PaginatorComponent) p: PaginatorComponent;
    @ViewChild('tableNomprCertiffourComponent') tableNomprCertiffourComponent: TableNomprCertiffourComponent;
    certif: CertifFournisseur[] = [];
    @Input() acheteur = false;
    searchOptions?: Partial<SearchOptions>;
    searchObject: SearchObject;
    count: number;

    searchh: SearchView<CertifFournisseur> = {
        loading: false,
        options: undefined,
        count: 0,
        results: [],
    };
    isLoading = {
        list: false,
    };
    isPublic: boolean = false;
    bizRegNo = null;
    hide = true;

    constructor(
        private datePipe: DatePipe,
        private toast: ToastService,
        private dialog: MatDialog,
        private certifFournisseurService: CertifFournisseurService,
        private searchObjectService: SearchObjectService,
        private router: Router,
        private changeDetectorRefs: ChangeDetectorRef,
        private sharedService: SharedSearchService,
        private CertifAchetService: CertifAchetService,
        private tranfer: Transferid
    ) {
    }

    ngOnInit(): void {
        this.isPublic = this.router.url.includes('public');

        if (!isEmpty(this.tranfer.getData())) {
            this.bizRegNo = this.tranfer.getData();
            this.onSearch(this.bizRegNo);
        }

        // this.initDataList();
    }

    initDataList() {
        this.isLoading.list = true;
        if (this.acheteur == false) {
            this.certifFournisseurService
                .searchCertifFour(this.searchObject)
                .subscribe({
                    next: (response) => {
                        this.searchh.results = response['payload']['data'];
                        //this.bizRegNo=response["payload"]["data"][0].masterCd
                        if (
                            response['payload']['data'][0].masterCd != undefined &&
                            response['payload']['data'][0].masterCd != null &&
                            response['payload']['data'][0].masterCd != ''
                        ) {
                            this.hide = false;
                        }
                        this.searchh.count = response['payload']['total'];
                        this.searchh.results.filter((column) => {
                            // this.datePipe.transform(column.bdRecvEndDt, "yyyy-MM-dd");
                            //  column.bdRecvEndDt = moment(column.bdRecvEndDt._d).format("YYYY-MM-DD");
                        });
                    },
                    error: () => {
                        this.isLoading.list = false;
                        this.toast.error('server_error');
                    },
                    complete: () => {
                        this.isLoading.list = false;
                    },
                });
        } else {
            this.CertifAchetService.searchCertifAch(this.searchObject).subscribe({
                next: (response) => {
                    this.searchh.results = response['payload']['data'];
                    //this.bizRegNo=response["payload"]["data"][0].masterCd
                    if (
                        response['payload']['data'][0].masterCd != undefined &&
                        response['payload']['data'][0].masterCd != null &&
                        response['payload']['data'][0].masterCd != ''
                    ) {
                        this.hide = false;
                    }
                    this.searchh.count = response['payload']['total'];
                    this.searchh.results.filter((column) => {
                        // this.datePipe.transform(column.bdRecvEndDt, "yyyy-MM-dd");
                        //  column.bdRecvEndDt = moment(column.bdRecvEndDt._d).format("YYYY-MM-DD");
                    });
                },
                error: () => {
                    this.isLoading.list = false;
                    this.toast.error('server_error');
                },
                complete: () => {
                    this.isLoading.list = false;
                },
            });
        }
    }

    onPaginate(pagination: Pagination) {
        this.searchObject.pagination = pagination;
        this.initDataList();
    }

    onSearch($event) {
        this.searchObject = this.searchObjectService.treatementSearchObject(
            10,
            0,
            null,
            null
        );

        this.searchObject.sort = {
            nameCol: 'regDt',
            direction: 'DESC',
        };
        this.searchObject.pagination.offSet = 0;
        this.searchObject.pagination.limit = 10;
        /*    this.p.paginator.pageIndex = 0; */
        this.searchObject.dataSearch = [];
        this.searchObject.dataSearch = $event;

        if (!isEmpty(this.tranfer.getData())) {
            this.bizRegNo = this.tranfer.getData();
            //this.onSearch(this.bizRegNo)
        } else {
            if ($event === null) {
                this.bizRegNo = null;
            } else {
                this.bizRegNo = $event[0].value;
            }
        }


        if ($event === null) {
            this.searchh.results = [];
        } else {
            this.initDataList();
        }
        /*    this.searchObject.pagination.offSet = 0;
        this.searchObject.pagination.limit = 10;
        this.p.paginator.pageIndex = 0;
        this.searchObject.dataSearch = [];
        this.searchObject.dataSearch = $event;*/
    }

    onSort(sort: any) {
        this.searchObject.sort = sort;

        this.onSearch(this.searchObject.dataSearch);
    }

    ngAfterContentChecked(): void {
        this.changeDetectorRefs.detectChanges();
    }

    enregistrer() {
        if (!this.acheteur) {
            this.router.navigate([
                '/portail/certif_fournisseur/add_certif',

                this.bizRegNo,
            ]);
        } else {
            this.router.navigate([
                '/portail/certif_acheteur/add_certif_ach',

                this.bizRegNo,
            ]);
        }
    }
}
